/**
 *  ResetPasswordModal script file
**/
import userService from '@/api/userService'

export default {
  name: 'ResetPasswordModal',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      confirmation: false,
      email: ''
    }
  },
  computed: {
    emailValid () {
      return this.email !== ''
    },
    formValid () {
      return this.emailValid
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async resetPassword () {
      this.loading = true
      try {
        await userService.resetPassword(this.email)
      } catch (err) {
        // eslint-disable-next-line
        console.error('[reset-password-modal.js] Error reseting password', err)
      }

      this.loading = false
      this.confirmation = true
      this.email = ''
    }
  }
}
